import o from "./design-system.es907.js";
import r from "./design-system.es896.js";
import e from "./design-system.es944.js";
function f(t) {
  return o(r(t)).left + e(t).scrollLeft;
}
export {
  f as default
};
//# sourceMappingURL=design-system.es909.js.map
